'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports["default"] = AssignFieldModal;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Modal = require('../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Select = require('../../Select');

var _Select2 = _interopRequireDefault(_Select);

var _getFileFieldsOptions = require('../helpers/getFileFieldsOptions');

var _getFileFieldsOptions2 = _interopRequireDefault(_getFileFieldsOptions);

var _assignFieldModalFooter = require('./assignFieldModalFooter');

var _assignFieldModalFooter2 = _interopRequireDefault(_assignFieldModalFooter);

var _selectedFieldsToAssign = require('./selectedFieldsToAssign');

var _selectedFieldsToAssign2 = _interopRequireDefault(_selectedFieldsToAssign);

var _preview = require('./preview');

var _preview2 = _interopRequireDefault(_preview);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function AssignFieldModal(props) {
  var isAssignFieldModalOpen = props.isAssignFieldModalOpen,
      onRequestClose = props.onRequestClose,
      columns = props.columns,
      databaseFieldToAssign = props.databaseFieldToAssign,
      onAssignField = props.onAssignField,
      fieldsMap = props.fieldsMap,
      data = props.data,
      attributes = props.attributes;
  var modalTitle = 'Assign to the field: ' + databaseFieldToAssign;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      fileFieldsOptions = _useState2[0],
      setFileFieldsOptions = _useState2[1];

  (0, _react.useEffect)(function () {
    if (fieldsMap[databaseFieldToAssign]) {
      var options = columns.filter(function (item) {
        return !fieldsMap[databaseFieldToAssign].split(',').includes(item);
      });
      return setFileFieldsOptions((0, _getFileFieldsOptions2["default"])(options));
    }

    return setFileFieldsOptions((0, _getFileFieldsOptions2["default"])(columns));
  }, [columns, databaseFieldToAssign, fieldsMap, isAssignFieldModalOpen]);

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      fileFieldsToAssign = _useState4[0],
      setFileFieldsToAssign = _useState4[1];

  var isAssignButtonDisabled = fileFieldsToAssign.length === 0;
  (0, _react.useEffect)(function () {
    if (fieldsMap[databaseFieldToAssign]) {
      return setFileFieldsToAssign(fieldsMap[databaseFieldToAssign].split(','));
    }

    return setFileFieldsToAssign([]);
  }, [fieldsMap, databaseFieldToAssign, isAssignFieldModalOpen]);

  var handleAssign = function handleAssign() {
    onRequestClose();
    onAssignField(databaseFieldToAssign, fileFieldsToAssign);
  };

  var selectFileField = function selectFileField(event) {
    var value = event.target.value;
    setFileFieldsOptions(fileFieldsOptions.filter(function (field) {
      return field.value !== value;
    }));
    setFileFieldsToAssign([].concat(_toConsumableArray(fileFieldsToAssign), [value]));
  };

  var deleteFileField = function deleteFileField(value) {
    setFileFieldsOptions([].concat(_toConsumableArray(fileFieldsOptions), [{
      label: value,
      value: value
    }]));
    setFileFieldsToAssign(fileFieldsToAssign.filter(function (field) {
      return field !== value;
    }));
  };

  var getModalContainerClassNames = function getModalContainerClassNames() {
    return (0, _classnames2["default"])({
      'rainbow-import-records-flow_step-three-assign-field-modal-content': !fileFieldsToAssign.length
    });
  };

  return _react2["default"].createElement(_Modal2["default"], {
    title: modalTitle,
    isOpen: isAssignFieldModalOpen,
    size: 'small',
    onRequestClose: onRequestClose,
    footer: _react2["default"].createElement(_assignFieldModalFooter2["default"], {
      onCancel: onRequestClose,
      onAssign: handleAssign,
      isAssignButtonDisabled: isAssignButtonDisabled
    })
  }, _react2["default"].createElement('div', {
    className: getModalContainerClassNames()
  }, _react2["default"].createElement(_Select2["default"], {
    className: 'rainbow-import-records-flow_step-three-field-select',
    label: 'Select Field To Assign',
    options: fileFieldsOptions,
    onChange: selectFileField,
    value: 'default'
  }), _react2["default"].createElement(_selectedFieldsToAssign2["default"], {
    values: fileFieldsToAssign,
    onDelete: deleteFileField
  }), _react2["default"].createElement(_preview2["default"], {
    field: databaseFieldToAssign,
    fileFields: fileFieldsToAssign,
    data: data,
    attributes: attributes
  })));
}

AssignFieldModal.propTypes = {
  isAssignFieldModalOpen: _propTypes2["default"].bool,
  onRequestClose: _propTypes2["default"].func,
  columns: _propTypes2["default"].array,
  databaseFieldToAssign: _propTypes2["default"].string,
  onAssignField: _propTypes2["default"].func,
  fieldsMap: _propTypes2["default"].object,
  data: _propTypes2["default"].array,
  attributes: _propTypes2["default"].object.isRequired
};
AssignFieldModal.defaultProps = {
  isAssignFieldModalOpen: false,
  onRequestClose: function onRequestClose() {},
  columns: [],
  databaseFieldToAssign: '',
  onAssignField: function onAssignField() {},
  fieldsMap: {},
  data: []
};